export default {
  SERVICE_STATUS: {
    error: 'ERROR',
    processed: 'PROCESSED',
    processing: 'PROCESSING',
  },
}
